import type { IconLoaders } from "../types";

/** Sidebar module menu and top bar */
export const appBarIcons = {
    account: () => import("./account"),
    anchor: () => import("./anchor"),
    arrow_left_bold: () => import("./arrow_left_bold"),
    arrow_right_bold: () => import("./arrow_right_bold"),
    arrows_swap: () => import("./arrows_swap"),
    bank: () => import("./bank"),
    campaigns: () => import("./campaigns"),
    chevron_up_down: () => import("./chevron_up_down"),
    code: () => import("./code"),
    cog: () => import("./cog"),
    cog_filled: () => import("./cog_filled"),
    customers: () => import("./customers"),
    dashboard: () => import("./dashboard"),
    docs: () => import("./docs"),
    external_link: () => import("./external_link"),
    gift_cards: () => import("./gift_cards"),
    integrations: () => import("./integrations"),
    more_vertical: () => import("./more_vertical"),
    orders: () => import("./orders"),
    partner: () => import("./partner"),
    payments: () => import("./payments"),
    phone_arrow_in: () => import("./phone_arrow_in"),
    profile: () => import("./profile"),
    question_circle: () => import("./question_circle"),
    reports: () => import("./reports"),
    shield_exclamation: () => import("./shield_exclamation"),
    split: () => import("./split"),
    store: () => import("./store"),
    switch_horizontal: () => import("./switch_horizontal"),
    terminal: () => import("./terminal"),
    triangle_down: () => import("./triangle_down"),
} satisfies IconLoaders;
